<template>
  <span v-if="openSearch" class="animationOpacity3">
    <div class="backgroundSearch animationOpacity2" @click="openSearch = false">
      <div class="flex-box container-box">
        <div class="content-box" @click.stop="toggle">
          <div class="busca-produto">
            <div class="spaceSearch">
              <div class="inputSearch">
                <img
                  src="@/assets/icons/search.svg"
                  class="search2"
                  @click="getCourse"
                />
                <img
                  src="@/assets/icons/closesearch.svg"
                  class="Pointer search"
                  @click="openSearch = false"
                />
                <b-form-input
                  v-model="searchCourse"
                  v-on:keyup.enter="getCourse"
                  id="step1"
                  class="input-busca"
                  :class="{ trocaBorda: searchCourse.length > 3 }"
                  :placeholder="$t('search_modal.label')"
                  autofocus
                  @input="getCourse"
                ></b-form-input>
              </div>
              <div v-if="searchCourse.length < 3" class="navegacaoInit">
                <div class="navegacaoItem">
                  <svg
                    style="width: 40px"
                    width="54"
                    height="24"
                    viewBox="0 0 54 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.979126"
                      width="24"
                      height="24"
                      rx="5"
                      fill="#333333"
                    />
                    <path
                      d="M12.9791 7V17M12.9791 17L17.9791 12M12.9791 17L7.97913 12"
                      stroke="white"
                      stroke-width="1.2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <rect
                      x="54"
                      y="24"
                      width="24"
                      height="24"
                      rx="5"
                      transform="rotate(180 54 24)"
                      fill="#333333"
                    />
                    <path
                      d="M42 17V7M42 7L37 12M42 7L47 12"
                      stroke="white"
                      stroke-width="1.2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <p>{{ $t('search_modal.text1') }}</p>
                </div>
                <div class="navegacaoItem">
                  <svg
                    style="width: 47px"
                    width="62"
                    height="30"
                    viewBox="0 0 62 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="61.75"
                      y="29.5"
                      width="61"
                      height="29"
                      rx="5"
                      transform="rotate(180 61.75 29.5)"
                      fill="#333333"
                    />
                    <path
                      d="M17.178 18.192V19.5H10.878V11.1H17.01V12.408H12.438V14.592H16.494V15.876H12.438V18.192H17.178ZM26.3811 11.1V19.5H25.0971L20.4651 13.812V19.5H18.9171V11.1H20.2011L24.8331 16.788V11.1H26.3811ZM30.3359 12.42H27.5519V11.1H34.6799V12.42H31.8959V19.5H30.3359V12.42ZM42.1507 18.192V19.5H35.8507V11.1H41.9827V12.408H37.4107V14.592H41.4667V15.876H37.4107V18.192H42.1507ZM49.3857 19.5L47.6697 17.04C47.5977 17.048 47.4897 17.052 47.3457 17.052H45.4497V19.5H43.8897V11.1H47.3457C48.0737 11.1 48.7057 11.22 49.2417 11.46C49.7857 11.7 50.2017 12.044 50.4897 12.492C50.7777 12.94 50.9217 13.472 50.9217 14.088C50.9217 14.72 50.7657 15.264 50.4537 15.72C50.1497 16.176 49.7097 16.516 49.1337 16.74L51.0657 19.5H49.3857ZM49.3497 14.088C49.3497 13.552 49.1737 13.14 48.8217 12.852C48.4697 12.564 47.9537 12.42 47.2737 12.42H45.4497V15.768H47.2737C47.9537 15.768 48.4697 15.624 48.8217 15.336C49.1737 15.04 49.3497 14.624 49.3497 14.088Z"
                      fill="white"
                    />
                  </svg>
                  <p>{{ $t('search_modal.text2') }}</p>
                </div>
                <div class="navegacaoItem">
                  <svg
                    style="width: 35px"
                    width="45"
                    height="30"
                    viewBox="0 0 45 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="45"
                      y="29.5"
                      width="45"
                      height="29"
                      rx="5"
                      transform="rotate(180 45 29.5)"
                      fill="#333333"
                    />
                    <path
                      d="M17.428 18.192V19.5H11.128V11.1H17.26V12.408H12.688V14.592H16.744V15.876H12.688V18.192H17.428ZM21.7711 19.62C21.1231 19.62 20.4951 19.528 19.8871 19.344C19.2871 19.16 18.8111 18.916 18.4591 18.612L18.9991 17.4C19.3431 17.672 19.7631 17.896 20.2591 18.072C20.7631 18.24 21.2671 18.324 21.7711 18.324C22.3951 18.324 22.8591 18.224 23.1631 18.024C23.4751 17.824 23.6311 17.56 23.6311 17.232C23.6311 16.992 23.5431 16.796 23.3671 16.644C23.1991 16.484 22.9831 16.36 22.7191 16.272C22.4551 16.184 22.0951 16.084 21.6391 15.972C20.9991 15.82 20.4791 15.668 20.0791 15.516C19.6871 15.364 19.3471 15.128 19.0591 14.808C18.7791 14.48 18.6391 14.04 18.6391 13.488C18.6391 13.024 18.7631 12.604 19.0111 12.228C19.2671 11.844 19.6471 11.54 20.1511 11.316C20.6631 11.092 21.2871 10.98 22.0231 10.98C22.5351 10.98 23.0391 11.044 23.5351 11.172C24.0311 11.3 24.4591 11.484 24.8191 11.724L24.3271 12.936C23.9591 12.72 23.5751 12.556 23.1751 12.444C22.7751 12.332 22.3871 12.276 22.0111 12.276C21.3951 12.276 20.9351 12.38 20.6311 12.588C20.3351 12.796 20.1871 13.072 20.1871 13.416C20.1871 13.656 20.2711 13.852 20.4391 14.004C20.6151 14.156 20.8351 14.276 21.0991 14.364C21.3631 14.452 21.7231 14.552 22.1791 14.664C22.8031 14.808 23.3151 14.96 23.7151 15.12C24.1151 15.272 24.4551 15.508 24.7351 15.828C25.0231 16.148 25.1671 16.58 25.1671 17.124C25.1671 17.588 25.0391 18.008 24.7831 18.384C24.5351 18.76 24.1551 19.06 23.6431 19.284C23.1311 19.508 22.5071 19.62 21.7711 19.62ZM30.6019 19.62C29.7539 19.62 28.9859 19.436 28.2979 19.068C27.6179 18.692 27.0819 18.176 26.6899 17.52C26.3059 16.864 26.1139 16.124 26.1139 15.3C26.1139 14.476 26.3099 13.736 26.7019 13.08C27.0939 12.424 27.6299 11.912 28.3099 11.544C28.9979 11.168 29.7659 10.98 30.6139 10.98C31.3019 10.98 31.9299 11.1 32.4979 11.34C33.0659 11.58 33.5459 11.928 33.9379 12.384L32.9299 13.332C32.3219 12.676 31.5739 12.348 30.6859 12.348C30.1099 12.348 29.5939 12.476 29.1379 12.732C28.6819 12.98 28.3259 13.328 28.0699 13.776C27.8139 14.224 27.6859 14.732 27.6859 15.3C27.6859 15.868 27.8139 16.376 28.0699 16.824C28.3259 17.272 28.6819 17.624 29.1379 17.88C29.5939 18.128 30.1099 18.252 30.6859 18.252C31.5739 18.252 32.3219 17.92 32.9299 17.256L33.9379 18.216C33.5459 18.672 33.0619 19.02 32.4859 19.26C31.9179 19.5 31.2899 19.62 30.6019 19.62Z"
                      fill="white"
                    />
                  </svg>
                  <p>{{ $t('search_modal.text3') }}</p>
                </div>
              </div>
            </div>
          </div>
          <div v-if="searchCourse.length >= 3"
            class="gridList animationOpacity2"
          >
            <div class="content-itens">
              <div>
                <p class="titleColumSearch" v-if="getAllSearch[1].length !== 0">
                  {{ $t('search_modal.text4') }}
                </p>
                <div
                  v-for="cursos in getAllSearch[1]"
                  :key="cursos.id"
                  :class="{
                    selectedItem_:
                      selectedItem.id === cursos.id &&
                      selectedItem.title === cursos.title,
                  }"
                  class="spaceCourse"
                  @click="getEvent()"
                >
                  <router-link
                    v-if="
                      (cursos.has_access === true &&
                        cursos.is_liberated === true) ||
                      permission
                    "
                    :to="{ name: 'curso', params: { curso: cursos.id } }"
                    class="removeLink"
                  >
                    <ListItensSearch
                      :typeSelectedItem="cursos"
                      :itemid="cursos.id"
                      :isMobile="isMobile"
                      :content="cursos"
                      :permission="permission"
                      :ratingHome="ratingHome"
                      :type="'module'"
                    />
                  </router-link>
                  <a v-else class="removeLink" @click="openModalBuy(cursos)">
                    <ListItensSearch
                      :typeSelectedItem="cursos"
                      :itemid="cursos.id"
                      :isMobile="isMobile"
                      :content="cursos"
                      :permission="permission"
                      :ratingHome="ratingHome"
                      :type="'module'"
                    />
                  </a>
                </div>
              </div>
              <div>
                <p class="titleColumSearch" v-if="getAllSearch[2].length !== 0">
                  {{ $t('search_modal.text5') }}
                </p>
                <div
                  v-for="modulos in getAllSearch[2]"
                  :key="modulos.id"
                  :class="{
                    selectedItem_:
                      selectedItem.id === modulos.id &&
                      selectedItem.title === modulos.title,
                  }"
                  class="spaceCourse"
                  @click="getEvent()"
                >
                  <router-link
                    v-if="
                      (modulos.course.has_access === true &&
                        modulos.is_liberated === true) ||
                      permission
                    "
                    :to="{
                      name: 'modulo',
                      params: { curso: modulos.course_id, modulo: modulos.id },
                    }"
                    class="removeLink"
                  >
                    <ListItensSearch
                      :typeSelectedItem="modulos"
                      :itemid="modulos.id"
                      :isMobile="isMobile"
                      :content="modulos"
                      :permission="permission"
                      :ratingHome="ratingHome"
                      :type="'module'"
                    />
                  </router-link>
                  <a v-else class="removeLink" @click="openModalBuy(modulos)">
                    <ListItensSearch
                      :typeSelectedItem="modulos"
                      :itemid="modulos.id"
                      :isMobile="isMobile"
                      :content="modulos"
                      :permission="permission"
                      :ratingHome="ratingHome"
                      :type="'module'"
                    />
                  </a>
                </div>
              </div>
              <div>
                <p v-if="getAllSearch[0].length !== 0" class="titleColumSearch">
                  {{ $t('search_modal.text6') }}
                </p>
                <div
                  v-for="lessons in getAllSearch[0]"
                  :key="lessons.id"
                  :class="{
                    selectedItem_:
                      selectedItem.id === lessons.id &&
                      selectedItem.title === lessons.title,
                  }"
                  class="spaceCourse"
                  @click="getEvent()"
                >
                  <router-link
                    v-if="
                      (lessons.course.has_access === true &&
                        lessons.is_liberated === true) ||
                      permission
                    "
                    :to="{
                      name: 'cursos',
                      params: {
                        curso: lessons.course_id,
                        modulo: lessons.module_id,
                        aula: lessons.id,
                      },
                    }"
                    class="removeLink"
                  >
                    <ListItensSearch
                      :typeSelectedItem="lessons"
                      :itemid="lessons.id"
                      :isMobile="isMobile"
                      :content="lessons"
                      :permission="permission"
                      :ratingHome="ratingHome"
                      :type="'lesson'"
                    />
                  </router-link>
                  <a v-else class="removeLink" @click="openModalBuy(lessons)">
                    <ListItensSearch
                      :typeSelectedItem="lessons"
                      :itemid="lessons.id"
                      :isMobile="isMobile"
                      :content="lessons"
                      :permission="permission"
                      :ratingHome="ratingHome"
                      :type="'lesson'"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </span>
</template>

<script>
import notify from "@/services/libs/notificacao"
import ListItensSearch from "@/components/ListItensSearch.vue"

import CourseService from "@/services/resources/CourseService"
import SearchService from "@/services/resources/SearchService"

const serviceCourse = CourseService.build()
const serviceSearch = SearchService.build()

export default {
  props: ["isMobile", "permission"],
  components: { ListItensSearch },
  created() {
    let that = this
    document.addEventListener("keyup", function (evt) {
      if (evt.keyCode === 27) {
        that.openSearch = false;
      } else if (evt.keyCode === 40) {
        that.getNextItem();
      } else if (evt.keyCode === 38) {
        that.getLastItem();
      }
    })
  },
  data() {
    return {
      openSearch: false,
      searchCourse: "",
      getAllSearch: [[], [], []],
      homeVertical: "16:9",
      ratingHome: true,
      selectedItem: null,
      typeSelectedItem: ""
    }
  },
  methods: {
    openModalBuy(data) {
      this.openSearch = false;
      if (data.is_liberated === false) {
        notify("erro", this.$t('search_modal.error.liberation'))
      } else {
        notify("erro", this.$t('search_modal.error.access'))
        let data = data.id + "/meta?keys[]=tipo_venda"
        serviceCourse
          .read(data)
          .then(resp => {
            if (resp.tipo_venda === "tela") {
              this.$router.push("/curso/venda/" + data.id)
            } else {
              this.$root.$emit("modal-buy-course", data)
              this.$root.$emit("bv::show::modal", "modal-buy", "#btnShow")
            }
          })
          .catch(err => console.log(err))
      }
    },
    async getHomeVertical() {
      let resp = await this.$store.dispatch("fetchMetas", [
        "home_vertical"
      ])
      var data = resp.home_vertical
      if (data === "off" || data === null) {
        this.homeVertical = "16:9"
      } else {
        this.homeVertical = "5:7"
      }
    },
    getLastItem() {
      let type = 1
      if (this.getAllSearch[1].length !== 0) {
        type = 1
      } else if (this.getAllSearch[0].length !== 0) {
        type = 0
      } else if (this.getAllSearch[2].length !== 0) {
        type = 2
      }
      if (this.typeSelectedItem !== "") {
        if (this.typeSelectedItem === "Aula") {
          type = 0
        } else if (this.typeSelectedItem === "Módulo") {
          type = 2
        } else if (this.typeSelectedItem === "Curso") {
          type = 1
        }
      }
      let array = this.getAllSearch[type]
      let elementPos = array
        .map(function (x) {
          return x.id
        })
        .indexOf(this.selectedItem.id)
      this.selectedItem = this.getAllSearch[type][elementPos - 1]
      if (this.selectedItem === undefined && type === 1) {
        type = 0
        let array = this.getAllSearch[type]
        if (array.length === 0) {
          type = 2
          array = this.getAllSearch[type]
          if (array.length === 0) {
            let last = this.getAllSearch[1].length
            this.addSelected(this.getAllSearch[1][last - 1], "Curso")
          } else {
            let last = this.getAllSearch[2].length
            this.addSelected(this.getAllSearch[2][last - 1], "Módulo")
          }
        } else {
          let last = this.getAllSearch[0].length
          this.addSelected(this.getAllSearch[0][last - 1], "Aula")
        }
      } else if (this.selectedItem === undefined && type === 2) {
        type = 1
        let array = this.getAllSearch[type]
        if (array.length === 0) {
          type = 1
          array = this.getAllSearch[type]
          if (array.length === 0) {
            let last = this.getAllSearch[0].length
            this.addSelected(this.getAllSearch[0][last - 1], "Aula")
          } else {
            let last = this.getAllSearch[1].length
            this.addSelected(this.getAllSearch[1][last - 1], "Curso")
          }
        } else {
          let last = this.getAllSearch[1].length
          this.addSelected(this.getAllSearch[1][last - 1], "Curso")
        }
      } else if (this.selectedItem === undefined && type === 0) {
        type = 2
        let array = this.getAllSearch[type]
        if (array.length === 0) {
          type = 1
          array = this.getAllSearch[type]
          if (array.length === 0) {
            let last = this.getAllSearch[0].length
            this.addSelected(this.getAllSearch[0][last - 1], "Aula")
          } else {
            let last = this.getAllSearch[1].length
            this.addSelected(this.getAllSearch[1][last - 1], "Curso")
          }
        } else {
          let last = this.getAllSearch[2].length;
          this.addSelected(this.getAllSearch[2][last - 1], "Módulo")
        }
      }
    },
    getNextItem() {
      let type = 1
      if (this.getAllSearch[1].length !== 0) {
        type = 1
      } else if (this.getAllSearch[0].length !== 0) {
        type = 0
      } else if (this.getAllSearch[2].length !== 0) {
        type = 2
      }
      if (this.typeSelectedItem !== "") {
        if (this.typeSelectedItem === "Aula") {
          type = 0
        } else if (this.typeSelectedItem === "Módulo") {
          type = 2
        } else if (this.typeSelectedItem === "Curso") {
          type = 1
        }
      }
      let array = this.getAllSearch[type]
      var elementPos = array
        .map(function (x) {
          return x.id
        })
        .indexOf(this.selectedItem.id)
      this.selectedItem = this.getAllSearch[type][elementPos + 1]
      if (this.selectedItem === undefined && type === 1) {
        type = 2
        let array = this.getAllSearch[type]
        if (array.length === 0) {
          type = 0
          array = this.getAllSearch[type]
          if (array.length === 0) {
            this.addSelected(this.getAllSearch[1][0], "Curso")
          } else {
            this.addSelected(this.getAllSearch[0][0], "Aula")
          }
        } else {
          this.addSelected(this.getAllSearch[2][0], "Módulo")
        }
      } else if (this.selectedItem === undefined && type === 2) {
        let array = this.getAllSearch[0]
        if (array.length === 0) {
          this.addSelected(this.getAllSearch[1][0], "Curso")
        } else {
          this.addSelected(this.getAllSearch[0][0], "Aula")
        }
      } else if (this.selectedItem === undefined && type === 0) {
        if (this.getAllSearch[1].length !== 0) {
          this.addSelected(this.getAllSearch[1][0], "Curso")
        } else if (this.getAllSearch[2].length !== 0) {
          this.addSelected(this.getAllSearch[2][0], "Módulo")
        } else if (this.getAllSearch[0].length !== 0) {
          this.addSelected(this.getAllSearch[0][0], "Aula")
        }
      }
    },
    addSelected(data, type) {
      this.selectedItem = data
      this.typeSelectedItem = type
    },
    getEvent() {
      let name = this.$route.name
      if (name === "curso" || name === "cursos" || name === "modulo") {
        this.$router.go()
      }
    },
    async getRating() {
      let resp = await this.$store.dispatch("fetchMetas", [
        "rating_home"
      ])
      if (resp.rating_home === null || resp.rating_home === "on") {
        this.ratingHome = true
      } else {
        this.ratingHome = false
      }
    },
    getCourse() {
      if (this.searchCourse.length < 3) {
        this.getAllSearch = [[], [], []]
      }
      this.$root.$emit("loadOn")
      serviceSearch
        .search2("search_string=" + this.searchCourse)
        .then(resp => {
          this.getAllSearch = Object.values(resp)
          if (this.getAllSearch[1].length !== 0) {
            this.selectedItem = this.getAllSearch[1][0]
            this.typeSelectedItem = "Curso"
          } else if (this.getAllSearch[2].length !== 0) {
            this.selectedItem = this.getAllSearch[2][0]
            this.typeSelectedItem = "Módulo"
          } else if (this.getAllSearch[0].length !== 0) {
            this.selectedItem = this.getAllSearch[0][0]
            this.typeSelectedItem = "Aula"
          }

          if (
            this.getAllSearch[0].length === 0 &&
            this.getAllSearch[1].length === 0 &&
            this.getAllSearch[2].length === 0
          ) {
            this.selectedItem = null
            this.getAllSearch = [[], [], []]
          }
        })
        .catch(err => console.error(err))
        .finally(() => this.$root.$emit("loadOff"))
    },
  },
  mounted() {
    this.getHomeVertical()
    this.$root.$on("openSearch", () => {
      this.openSearch = true
    })
  }
}
</script>

<style scoped lang="scss">
.backgroundSearch {
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
}

.dataLista {
  p {
    font-family: Montserrat;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: #81858e;
    display: flex;
  }
  p::before {
    content: "";
    width: 7px;
    height: 7px;
    border-radius: 50%;
    border: 2px solid #333333;
    background: #333333;
    display: block;
    margin-right: 8px;
    margin-top: 6px;
  }
}

.dataCriado {
  display: flex;
  margin-top: -6px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  color: #81858e;
}

.navegacaoInit {
  padding: 20px;
  display: flex;
  justify-content: space-between;
  .navegacaoItem {
    display: flex;
    p {
      font-family: Montserrat;
      font-style: normal;
      font-weight: normal;
      font-size: 11px;
      color: #000916;
      display: flex;
      margin-left: 10px;
      position: relative;
      top: 7px;
    }
  }
}

.flex-box {
  display: flex;
  align-items: center;
  justify-content: center;
}

.actionsMenuAndInfo {
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  width: 100%;
  text-decoration: none;
  padding: 20px;
  margin: auto;
  justify-content: space-around;
}

.actionsMenuAndInfo a {
  margin-right: 10px;
  display: flex;
  color: var(--fontcolor);
}

.actionsMenuAndInfo a img {
  margin-right: 10px;
  filter: var(--filtericon);
}

.container-box {
  background-color: #ffffff00;
  height: 50%;
}

.spaceCourse {
  padding: 8px 3px;
  cursor: pointer;
}

.spaceSearch {
  background: white;
  border-radius: 5px;
}

.spaceCourse.selectedItem {
  background: #e8e8e866;
}

.content-box {
  background-color: #bfbfbf00;
  color: white;
  text-align: center;
  width: 65%;
  height: 100%;
  transition: 0.3s;
  border-radius: 0 5px;
  margin-top: 110px;
}

.gridList {
  background-color: #fffffff7;
  height: 100%;
  width: 100%;
  transition: 0.3s;
  border-radius: 0px 0px 5px 5px;
}

.previewItem {
  height: 100%;
  width: 100%;
  background-color: #fffffff7;
  transition: 0.3s;
  padding: 20px 50px;
  border-radius: 3px;
  .spaceContent {
    width: 80%;
    margin: auto;
  }
  .spaceContent2 {
    width: 40%;
    margin: auto;
  }
  .spaceContentItens {
    width: 80%;
    margin: auto;
    margin-top: 25px;
  }
}

.spaceImagemPreview {
  border-radius: 3px;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.nameItem {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: #333;
  display: flex;
  justify-content: space-between;
  width: 100%;
  .ativo {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    color: #00e4a0;
    display: flex;
  }
  .ativo::before {
    content: "";
    width: 7px;
    height: 7px;
    border-radius: 50%;
    border: 2px solid #00e4a0;
    background: #00e4a0;
    display: block;
    margin-right: 8px;
    margin-top: 4px;
  }
  .inativo {
    color: #ff0c37 !important;
  }
  .inativo::before {
    border: 2px solid #ff0c37 !important;
    background: #ff0c37 !important;
  }
}

.content-itens {
  height: 100%;
  width: 100%;
  transition: 0.3s;
  overflow: auto;
  background-color: #fffffff7;
  border-radius: 3px;
}

.titleColumSearch {
  font-size: 15px;
  font-weight: 600;
  display: flex;
  align-items: center;
  color: #333333;
  margin-top: 25px;
}

.titleColumSearch::before {
  content: "";
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 2px solid var(--maincolor);
  background: var(--maincolortrans);
  display: block;
  margin-right: 20px;
  margin-left: 15px;
}

.trocaBorda {
  border-radius: 5px 5px 0px 0px !important;
}

.removeLink {
  text-decoration: none;
}

.inputSearch {
  position: relative;
}
.input-busca {
  width: 100%;
  height: 60px;
  background: #ffffff;
  border: none;
  border-radius: 5px 5px 0px 0px;
  border-bottom: solid 1px #ededf0;
  padding: 20px 42px;
  font-family: Montserrat;
  font-weight: normal;
  color: #81858e;
  font-size: 14px;
  transition: 0.3s;
}
.input-busca:hover,
.input-busca:focus {
  box-shadow: 0 6px 12px rgba(30, 60, 90, 0.2);
}
.search {
  position: absolute;
  right: 30px;
  top: 22px;
  width: 14.7px;
  height: 14.7px;
  z-index: 999;
  transition: 0.3s;
  cursor: pointer;
}

.search2 {
  position: absolute;
  top: 22px;
  width: 14.7px;
  height: 14.7px;
  z-index: 999;
  transition: 0.3s;
  left: 18px;
  cursor: pointer;
}

.action-box {
  width: 100%;
  height: 100%;
  background: rgba(0, 2, 23, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: 0.3s;
  z-index: 1;
  position: absolute;
  top: 0;
  border-radius: 5px;
}

.action-boxmobile {
  width: 100%;
  height: 100%;
  background: rgba(0, 2, 23, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: 0.3s;
  z-index: 1;
  position: absolute;
  top: 0;
  border-radius: 5px;
}

.action-box a:first-child {
  margin-right: 30px;
}
.action-box a {
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
}
.action-box a img {
  margin-right: 10px;
}

.action-boxmobile a:first-child {
  margin-right: 30px;
}

.action-boxmobile a {
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
}
.action-boxmobile a img {
  margin-right: 10px;
}

.spaceContent:hover .action-box {
  opacity: 1 !important;
}

.spaceContent:hover .action-boxmobile {
  opacity: 1 !important;
}

.spaceContent2:hover .action-box {
  opacity: 1 !important;
}

.spaceContent2:hover .action-boxmobile {
  opacity: 1 !important;
}

.content-itens::-webkit-scrollbar {
  background-color: #fff;
  width: 2px;
}

.content-itens::-webkit-scrollbar-track {
  background-color: #c7c7c7;
}

.content-itens::-webkit-scrollbar-thumb {
  background-color: #4d4d4d52;
  border-radius: 31px;
}

.content-itens::-webkit-scrollbar-button {
  display: none;
}

.spaceCourse {
  a {
    height: 100%;
  }
}
</style>